var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoumentIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.04,
    height: 31.252,
    viewBox: "0 0 24.04 31.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.174,3.375H9.755A3,3,0,0,0,6.75,6.38V31.622a3,3,0,0,0,3.005,3.005h18.03a3,3,0,0,0,3.005-3.005V12.991Zm-1.2,10.818V5.779l8.414,8.414Z",
    transform: "translate(-6.75 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoumentIconDark);
export default __webpack_public_path__ + "static/media/doument-icon-dark.53fe7c4aa8985a80fb0ffb8f4fffaa4e.svg";
export { ForwardRef as ReactComponent };